import React from 'react';

import InboundAttendanceStatusHandler from './components/InboundAttendanceStatusHandler';
import StoneLayout from './layouts';

interface InboundContainerStyledProps {
  children: React.ReactNode;
}
const InboundContainerStyled: React.FC<InboundContainerStyledProps> = ({
  children,
}) => {
  return (
    <StoneLayout>
      <InboundAttendanceStatusHandler>
        {children}
      </InboundAttendanceStatusHandler>
    </StoneLayout>
  );
};

export default InboundContainerStyled;
